const c = ({
  params: e,
  relative: r = !1
} = {}) => {
  const t = new URL(window.location.href);
  if (e)
    for (const s of Object.keys(e))
      t.searchParams.set(s, String(e[s]));
  return r ? `${t.pathname}${t.search}` : t.href;
}, o = ({
  relative: e = !1,
  queryString: r = !0
} = {}) => {
  const t = new URL(window.location.href);
  return r || (t.search = ""), e ? `${t.pathname}${t.search}` : t.href;
}, a = (e) => e ? /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i.test(
  e
) : !1, n = new RegExp("^(?:[a-z+]+:)?//", "i"), i = (e) => !!e && n.test(e), l = (e, r) => {
  const t = new URL(e);
  for (const s of Object.keys(r))
    t.searchParams.set(s, String(r[s]));
  return t.href;
};
function f(e) {
  return e && e.replace(/(wss?:\/\/|wss?:)/g, "").replace("/socket", "").replace("/websocket", "");
}
export {
  l as addQueryParams,
  c as buildCurrentUrl,
  o as getCurrentUrl,
  f as getDomainKeyFromUrl,
  i as isRelativeUrl,
  a as isValidUrl
};
